module.exports = __webpack_public_path__ + "static/sygnet_color_left-39b159a982621477e8e1faed5fc9fc03.svg";